import React from 'react';

import Button from '../../UI/Button';
import OnboardingImg from '../../Icons/images/fastagOnboard.jpg';
import Icon from '../../Icons';

import { Container } from './styles';

const Onboarding = () => (
  <Container className="bg-white">
    <img src={OnboardingImg} alt="Fastag" />
    <div className="p30">
      <p className="fwb extra-large">Join the family with 5.5 lac trucks.</p>
      <p className="mt24 largest">Get Fastags from Wheelseye.</p>
      <ul className="mt24">
        <li className="mt16">
          <span className="mr16">
            <Icon name="green-checklist" />
          </span>
          <span>Single platform for GPS tracking and Fastag recharges.</span>
        </li>
        <li className="mt16">
          <span className="mr16">
            <Icon name="green-checklist" />
          </span>
          <span>Multiple recharge options.</span>
        </li>
        <li className="mt16">
          <span className="mr16">
            <Icon name="green-checklist" />
          </span>
          <span>Automatic reconciliation of data.</span>
        </li>
      </ul>
      <div className="mt40">
        <Button
          variant="contained"
          color="#304FFE"
          style={{ padding: '2px 26px', height: '40px' }}
          clickHandler={() =>
            window.open(
              'https://docs.google.com/forms/d/e/1FAIpQLSetdpEZCCSp40tGLWhkbv1ouctpnrFugfjGCeQbpjHEg6gSvg/viewform',
            )
          }
        >
          Click here to get Fastag
        </Button>
      </div>
    </div>
  </Container>
);

export default Onboarding;
